import React, { useRef, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";

import ScrollAnimation from "../ScrollAnimation";

/**
 * Chrome de seção compartilhado por Construtoras (Incorporação) e
 * InvestirMorar (Dos nossos clientes): cabeçalho + setas + Swiper.
 * Não busca dados nem conhece regras de negócio — recebe `items` já
 * filtrados pelo componente pai e apenas os apresenta.
 */
function PropertyShowcaseCarousel({
  eyebrow,
  title,
  items,
  getItemKey,
  renderItem,
  emptyLabel = "Carregando imóveis...",
  footer,
  variant = "default",
  navPrevLabel = "Ver imóveis anteriores",
  navNextLabel = "Ver próximos imóveis",
}) {
  const swiperRef = useRef(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const updateNavState = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <section
      className={`showcase-section${variant === "muted" ? " showcase-section--muted" : ""}`}
    >
      <ScrollAnimation animation="fade-up" duration={1500}>
        <div className="showcase-section__inner">
          <div className="showcase-section__header">
            <div className="showcase-section__heading">
              <h2 className="showcase-section__eyebrow">{eyebrow}</h2>
              <h3 className="showcase-section__title">{title}</h3>
            </div>
            <div className="showcase-section__nav">
              <button
                type="button"
                className="showcase-nav-button"
                aria-label={navPrevLabel}
                disabled={isBeginning}
                onClick={() => swiperRef.current?.slidePrev()}
              >
                <FaChevronLeft />
              </button>
              <button
                type="button"
                className="showcase-nav-button"
                aria-label={navNextLabel}
                disabled={isEnd}
                onClick={() => swiperRef.current?.slideNext()}
              >
                <FaChevronRight />
              </button>
            </div>
          </div>

          <div className="showcase-section__viewport">
            {items.length > 0 ? (
              <Swiper
                modules={[FreeMode, A11y]}
                onSwiper={(swiper) => {
                  swiperRef.current = swiper;
                  updateNavState(swiper);
                }}
                onSlideChange={updateNavState}
                onReachBeginning={updateNavState}
                onReachEnd={updateNavState}
                onFromEdge={updateNavState}
                watchOverflow
                slidesPerView="auto"
                spaceBetween={20}
                loop={false}
                autoplay={false}
                grabCursor
                resistanceRatio={0.65}
                freeMode={{ enabled: true, momentum: true, momentumRatio: 0.8, sticky: false }}
                className="showcase-swiper"
              >
                {items.map((item, index) => (
                  <SwiperSlide key={getItemKey(item)} className="showcase-slide">
                    {renderItem(item, index)}
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <p className="showcase-section__empty">{emptyLabel}</p>
            )}
          </div>

          {footer}
        </div>
      </ScrollAnimation>
    </section>
  );
}

export default PropertyShowcaseCarousel;
